import { Zone } from '@/core/api/entities/zone/zone'
import { ZoneConnection } from '@/core/api/entities/zone/zoneConnection'

import {
	ConnectionStatus,
	DailyData,
	HourlyData,
} from '../components/ConnectionChart'

export const getHasSmartIntegration = (zone: Zone) => {
	return zone.integrationSource !== null && zone.integrationSource !== undefined
}

export const transformConnectionData = (
	connections: ZoneConnection[],
	maxDays?: number
): DailyData[] => {
	const days = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	]

	// Sort connections by date (most recent first)
	const sortedConnections = [...connections].sort((a, b) => {
		return new Date(b.date).getTime() - new Date(a.date).getTime()
	})

	// Filter out today and take only complete days
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	const completedDays = sortedConnections.filter((connection) => {
		const connectionDate = new Date(connection.date)
		connectionDate.setHours(0, 0, 0, 0)
		return connectionDate.getTime() < today.getTime()
	})

	// Limit to maxDays if specified (default: 7 for daily view, undefined for hourly view)
	const daysToShow =
		maxDays !== undefined ? completedDays.slice(0, maxDays) : completedDays

	return daysToShow.map((connection) => {
		const date = new Date(connection.date)
		const dayName = days[connection.dayOfWeek]

		// Transform hourly connections
		const hourlyData: HourlyData[] = Array.from({ length: 24 }, (_, hour) => {
			const hourFormatted = hour.toString().padStart(2, '0')
			const isConnected = connection.connections[hourFormatted] === true
			const timestamp = new Date(date)
			timestamp.setHours(hour, 0, 0, 0)

			return {
				hour,
				status: isConnected
					? ConnectionStatus.STABLE
					: ConnectionStatus.NO_CONNECTION,
				timestamp,
			}
		})

		// Calculate overall status for daily view
		const stableCount = hourlyData.filter(
			(h) => h.status === ConnectionStatus.STABLE
		).length
		let overallStatus: ConnectionStatus

		if (stableCount > 7) {
			overallStatus = ConnectionStatus.STABLE
		} else if (stableCount > 1) {
			overallStatus = ConnectionStatus.POOR
		} else {
			overallStatus = ConnectionStatus.NO_CONNECTION
		}

		return {
			day: dayName,
			date,
			hourlyData,
			overallStatus,
		}
	})
}
